// extracted by mini-css-extract-plugin
module.exports = {"section":"tabbedImages-module--section--38mv_"};